import { memo } from 'react';

import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';

import getSharedAsset from '../utils/sharedAssetMap';

export const SubscriptionAsset = memo(function SubscriptionAsset({ service, included }) {
  if (included) {
    return null;
  }

  const assetUrl = getSharedAsset(service);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        alignSelf: 'baseline',
      }}
    >
      <img src={assetUrl} alt={service} width={50} height={50} />
    </Box>
  );
});

SubscriptionAsset.propTypes = {
  service: PropTypes.string.isRequired,
  included: PropTypes.bool,
};
